import { render } from "./WorkItem.vue?vue&type=template&id=69644295&scoped=true"
import script from "./WorkItem.vue?vue&type=script&lang=js"
export * from "./WorkItem.vue?vue&type=script&lang=js"

import "./WorkItem.vue?vue&type=style&index=0&id=69644295&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69644295"

export default script